// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"dae81519","177":"5291d4e9","770":"e5bc71e9"}[chunkId] + ".js";
};